import {Service} from './request';
import Config from '../core/config/config';

export default {
    sendSMS(params) {
        // let param = {
        //     phone: phone
        // };
        return Service.post("common/send/sms/by/name/and/phone", params);
    },
    getLogo() {
        let param = {
            "domainName": Config.getHost()
        }
        return Service.post("/resource/select/logo/info", param);
    }
}